import { render, staticRenderFns } from "./ThePage.vue?vue&type=template&id=2d52bb74&scoped=true"
import script from "./ThePage.vue?vue&type=script&lang=js"
export * from "./ThePage.vue?vue&type=script&lang=js"
import style0 from "./ThePage.vue?vue&type=style&index=0&id=2d52bb74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d52bb74",
  null
  
)

export default component.exports